
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.358 9.93l5.24 5.409c.221.228.578.228.799 0l5.24-5.408a.864.864 0 000-1.194.8.8 0 00-1.156 0l-4.484 4.626-4.482-4.626a.801.801 0 00-1.157 0 .864.864 0 000 1.194z","fill":"#E6007E"}})])
          )
        }
      }
    